(() => {
  function closeMenu(menu, focus = false) {
    menu.open = false;
    menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    if (focus) menu.querySelector('summary')?.focus();
  }
  function setup(root = document) {
    root.querySelectorAll('[data-ht-menu], [data-ht-dropdown]').forEach(menu => {
      if (menu.dataset.htReady) return;
      menu.dataset.htReady = 'true';
      const summary = menu.querySelector('summary');
      summary?.setAttribute('aria-expanded', String(menu.open));
      menu.addEventListener('toggle', () => {
        summary?.setAttribute('aria-expanded', String(menu.open));
        if (menu.open && menu.matches('[data-ht-dropdown]')) {
          menu.parentElement.querySelectorAll(':scope > [data-ht-dropdown][open]').forEach(other => {
            if (other !== menu) closeMenu(other);
          });
        }
      });
    });
  }
  setup();
  const compactCatalog = window.matchMedia('(max-width: 749px)');
  const resizeCatalog = () => document.querySelectorAll('[data-ht-catalog]').forEach(menu => { menu.open = !compactCatalog.matches; });
  resizeCatalog();
  compactCatalog.addEventListener('change', resizeCatalog);
  document.addEventListener('shopify:section:load', resizeCatalog);
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-ht-dropdown][open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) closeMenu(menu);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-ht-dropdown][open]').forEach(menu => closeMenu(menu, menu.contains(event.target)));
  });
})();
